// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"440":"datadogProfiler","581":"datadogRecorder"}[chunkId] || chunkId) + "." + {"142":"7774aa2f","187":"67292018","440":"e5f15700","581":"705f43d0","653":"5db6480d","917":"79190701"}[chunkId] + ".chunk.js";
};